import React from 'react';
import { XIcon, CheckIcon, FlameIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { handleCartClick, CART_URL } from '../utils/metaPixel';
export function FinalCTA() {
  return <section className="py-14 md:py-20 bg-gradient-to-b from-dark to-[#1f1f35] relative overflow-hidden" data-id="element-59">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-60">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-rose-900/30 rounded-full blur-3xl" data-id="element-61"></div>
        <div className="absolute bottom-0 -left-24 w-72 h-72 bg-gold-900/20 rounded-full blur-3xl" data-id="element-62"></div>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-63">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-64">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-65">
            Ahora Tienes Dos Opciones
          </h2>
          <div className="w-24 h-1 bg-rose-600 mx-auto rounded-full" data-id="element-66"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 mb-16" data-id="element-67">
          {/* Option 1: The Bad Way */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white/5 p-8 rounded-3xl border border-white/10 flex flex-col space-y-6 opacity-80 hover:opacity-100 transition-opacity" data-id="element-68">
            <div className="w-16 h-16 rounded-full bg-white/10 flex items-center justify-center mx-auto mb-4" data-id="element-69">
              <XIcon className="w-8 h-8 text-gray-400" data-id="element-70" />
            </div>

            <ul className="space-y-4 flex-1" data-id="element-71">
              <li className="flex items-start font-medium text-[#DFE0EC]" data-id="element-72">
                ✖️ Seguir enviando mensajes que Él ignora
              </li>
              <li className="flex items-start font-medium text-[#DFE0EC]" data-id="element-73">
                ✖️ Seguir dudando qué decir
              </li>
              <li className="flex items-start font-medium text-[#DFE0EC]" data-id="element-74">
                ✖️ Seguir sintiéndote una opción
              </li>
            </ul>
          </motion.div>

          {/* Option 2: The Good Way */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-br from-rose-600 to-rose-800 p-8 rounded-3xl shadow-2xl border-2 border-gold-400/50 flex flex-col space-y-6 transform md:scale-105 relative" data-id="element-75">
            <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-gold-400 text-dark font-bold px-6 py-2 rounded-full shadow-lg border border-gold-300 pl-[12px] pr-[12px]" data-id="element-76">
              LA MEJOR OPCIÓN
            </div>

            <div className="w-16 h-16 rounded-full bg-white/10 flex items-center justify-center mx-auto mb-4 border border-white/20" data-id="element-77">
              <FlameIcon className="w-8 h-8 text-gold-400" data-id="element-78" />
            </div>

            <ul className="space-y-4 flex-1" data-id="element-79">
              <li className="flex items-start text-white font-bold text-lg" data-id="element-80">
                ✅ Empezar a usar mensajes que generan atracción real
              </li>
              <li className="flex items-start text-rose-100 text-lg font-[700]" data-id="element-81">
                ✅ Hacer que él invierta
              </li>
              <li className="flex items-start text-rose-100 text-lg font-[700]" data-id="element-82">
                ✅ Hacer que él te busque
              </li>
              <li className="flex items-start text-rose-100 text-lg font-[700]" data-id="element-83">
                ✅ Hacer que él te priorice
              </li>
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-2xl mx-auto" data-id="element-84">
          <p className="text-2xl font-bold text-white mb-8 italic underline decoration-rose-500/50 underline-offset-4" data-id="element-85">
            Sabes cuál opción necesitas elegir.
          </p>

          <a href={CART_URL} onClick={handleCartClick} className="inline-block w-full bg-rose-600 hover:bg-rose-700 text-white text-xl md:text-2xl font-bold py-6 px-8 rounded-2xl shadow-[0_10px_20px_rgba(225,29,72,0.3)] hover:shadow-[0_15px_30px_rgba(225,29,72,0.4)] transform hover:-translate-y-1 transition-all duration-300 animate-pulse-slow" data-id="element-86">
            👉 ACCEDER AL MENSAJES MAGNÉTICOS AHORA
          </a>
        </motion.div>
      </div>
    </section>;
}